<template>
	<div>
		<div style="font-size:20px;float:left;margin:35px 0 0 40px;font-weight:600">员工转正</div>
		<div style="height:780px;background-color:white;margin:75px 40px 0 40px">

			<div style="margin-left:3%">
				<div style="height:30px"></div>
				<span style="margin-right:10px">组织架构</span>
				<el-cascader v-model="condition.organize_ids" clearable
					style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
				<span style="margin-right:10px;margin-left:10px">城市</span>
				<el-select style="margin-left:10px;width:150px" v-model="condition.city_id" placeholder="全部" clearable>
					<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city" :value="item.city">
					</el-option>
				</el-select>
				<span style="margin-right:10px;margin-left:10px">职位</span>
				<el-select style="margin-left:10px;width:150px" v-model="condition.post_id" placeholder="全部" clearable>
					<el-option v-for="item in gwList" :key="item.value" :label="item.post_name" :value="item.id">
					</el-option>
				</el-select>
				<span style="margin-right:10px;margin-left:10px">姓名</span>
				<el-input class="input" v-model="condition.staff_name" placeholder="请输入姓名"></el-input>
				<span style="margin-right:10px;margin-left:10px">身份证号</span>
				<el-input class="input" v-model="condition.staff_card" placeholder="请输入身份证号"></el-input>
				<br>
				<div class="rz">
					<span style="margin-right:10px;margin-left:10px">入职日期</span>
					<el-date-picker style="width:25%" v-model="condition.start_date" type="datetimerange" clearable
						range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd HH:mm" end-placeholder="结束日期"
						value-format="yyyy-MM-dd HH:mm">
					</el-date-picker>
					<span style="margin-right:10px;margin-left:10px">转正时间</span>
					<el-date-picker v-model="condition.formal_date" type="date" placeholder="选择日期" clearable>
					</el-date-picker>
					<span style="margin-right:10px;margin-left:10px">状态</span>
					<el-select style="margin-right:10px" v-model="condition.is_formal" placeholder="全部" clearable>
						<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button style="width:85px;height:41px" type="goon" @click="Find">查询</el-button>
					<div style="display:inline-block;margin-left:220px">
						<download-excel class="export-excel-wrapper" :fields="download_excel" title="转正人员清单"
									name="转正人员清单.xls" :fetch="ExportForm"
									style="margin-left:-180px;top:100px">
							<el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
								导表</el-button>
						</download-excel>
					</div>

				</div>
				
			</div>

			<div style="margin:3% 2% 0 2%">
				<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
					:data="tableData" tooltip-effect="dark" style="width: 100%" height="530"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column align="center" label="组织架构" width="300">
						<template slot-scope="scope">
							{{$globals.group_name + "/" + scope.row.organize_name}}
						</template>
					</el-table-column>
					<el-table-column prop="city_id" label="城市" align="center">
					</el-table-column>
					<el-table-column prop="post_name" label="职位" align="center">
					</el-table-column>
					<el-table-column prop="staff_name" label="姓名" align="center">
					</el-table-column>
					<el-table-column prop="staff_card" label="身份证号码" align="center">
					</el-table-column>
					<el-table-column prop="staff_telephone" label="手机号码" align="center">
					</el-table-column>
					<el-table-column prop="trial_salary" label="试用期薪酬" align="center">
					</el-table-column>
					<el-table-column label="试用期起止时间" align="center">
						<template slot-scope="scope">
							{{scope.row.start_date + "—" + scope.row.end_date}}
						</template>
					</el-table-column>
					<el-table-column prop="formal_date" label="转正时间" align="center">
					</el-table-column>
					<el-table-column prop="formal_salary" label="转正薪筹" align="center">
					</el-table-column>
					<el-table-column prop="" label="状态" align="center">
						<template slot-scope="scope">
							<img src="../../../assets/stateImg/状态_未生效.png" v-show="scope.row.is_formal === '0' " />
							<img src="../../../assets/stateImg/状态_已生效.png" v-show="scope.row.is_formal === '1' " />
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" fixed="right" width="120">
						<template slot-scope="scope">
							<el-button type="qian" @click="zhuanzheng(scope.row)" v-show="scope.row.is_formal === '0' " >转正</el-button>
							<el-button type="qian" style="background-color:#f6f6f6 ; color: #000000 ; border-color:#f6f6f6 " v-show="scope.row.is_formal === '1' " >转正</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-dialog title="转正" :visible.sync="centerDialogVisible" width="30%" center>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
						<div>
							<el-row>
								<el-col>
									<el-form-item label="转正时间" prop="formal_date">
										<el-date-picker style="width:70%" v-model="ruleForm.formal_date" type="date"
											value-format="yyyy-MM-dd" placeholder="选择日期">
										</el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>

							<el-row>
								<el-col>
									<el-form-item label="转正薪资" prop="formal_salary">
										<el-input style="width:70%" v-model="ruleForm.formal_salary"
											placeholder="请输入转正薪资"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</div>

						<el-form-item style="margin-left:80px">
							<el-button type="goon" @click="AddAuditor('ruleForm')">保 存</el-button>
						</el-form-item>
					</el-form>
				</el-dialog>

				<!-- 分页 -->
				<el-row style="margin-top: 10px; margin-left: 500px;">
					<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
						layout=" prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-row>
			</div>
		</div>
		<el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="13" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			SelectAuditor: SelectAuditor,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				page_num: 1,
				page_size: 10,
				total: 0,
				centerDialogVisible: false,
				dialogAuditorVisible: false,
				input1: '',
				activeIndex: '1',
				activeIndex2: '1',
				//状态数据
				ztList: [{
					value: '0',
					label: '未生效'
				}, {
					value: '1',
					label: '已生效'
				}],
				ruleForm: {
					post_id: '',
					staff_name: '',
					start_date: '',
					end_date: '',
					company_id: '',
					modular_id: '',
					city_id: '',
					project_id: '',
					formal_date: '',
					is_formal: '',
					staff_card: '',
					induction_time: '',
					staff_telephone: '',
					project_name: '',
					modular_name: '',
					company_name: '',
					post_name: '',
					id: '',
					formal_salary: '',
					examineDetailsList: [],
				},
				//条件
				condition: {
					organize_ids: [],
					post_id: '',
					staff_name: '',
					start_date: '',
					end_date: '',
					company_id: '',
					modular_id: '',
					city_id: '',
					project_id: '',
					formal_date: '',
					is_formal: '',
					staff_card: '',
					induction_time: '',
					staff_telephone: '',
					project_name: '',
					modular_name: '',
					company_name: '',
					post_name: '',
					id: '',
					formal_salary: '',
				},
				multipleSelection: [],
				options: [{}],
				input: '',
				fgsList: [],
				bkList: [],
				xmList: [],
				gwList: [],
				fgsList: [],
				fgsList: [],
				tableData: [],

				download_excel: {
				    "组织架构": "organize_name",
				    "姓名": "staff_name",
					"性别":"staff_gender",
				    "职位": "post_name",
				    "身份证号": "staff_card",
				    "手机号": "staff_telephone",
				    "试用期薪酬": "trial_salary",
					"试用期开始": "start_date",
					"试用期结束": "end_date",
					"转正时间": "formal_date",
					"转正薪筹": "formal_salary",
				},

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},

			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'staff/selectWhole';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					city_id: this.condition.city_id,
					post_id: this.condition.post_id,
					staff_name: this.condition.staff_name,
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[0] : '',
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[1] : '',
					formal_date: this.condition.formal_date,
					staff_card: this.condition.staff_card,
					induction_time: this.condition.induction_time,
					staff_telephone: this.condition.staff_telephone,
					is_formal: this.condition.is_formal,
					project_name: this.condition.project_name,
					modular_name: this.condition.modular_name,
					company_name: this.condition.company_name,
					post_name: this.condition.post_name,
					formal_salary: this.condition.formal_salary,
					id: this.condition.id,
					applicant_id:this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			// 导表
			async ExportForm(){
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'staff/selectWholes';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					city_id: this.condition.city_id,
					post_id: this.condition.post_id,
					staff_name: this.condition.staff_name,
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[0] : '',
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[1] : '',
					formal_date: this.condition.formal_date,
					staff_card: this.condition.staff_card,
					induction_time: this.condition.induction_time,
					staff_telephone: this.condition.staff_telephone,
					is_formal: this.condition.is_formal,
					project_name: this.condition.project_name,
					modular_name: this.condition.modular_name,
					company_name: this.condition.company_name,
					post_name: this.condition.post_name,
					formal_salary: this.condition.formal_salary,
					id: this.condition.id,
					applicant_id:this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
							this.$message.success("没有可以导出的数据！");
							return null;
						}
						
					} else {
						this.$message.warning(data);
					}
				}
			},
			zhuanzheng(e) {
				this.centerDialogVisible = true;
				this.ruleForm.post_id = e.post_id;
				this.ruleForm.staff_name = e.staff_name;
				this.ruleForm.start_date = e.start_date;
				this.ruleForm.end_date = e.end_date;
				this.ruleForm.company_id = e.company_id;
				this.ruleForm.modular_id = e.modular_id;
				this.ruleForm.city_id = e.city_id;
				this.ruleForm.project_id = e.project_id;
				this.ruleForm.formal_date = e.formal_date;
				this.ruleForm.is_formal = e.is_formal;
				this.ruleForm.staff_card = e.staff_card;
				this.ruleForm.induction_time = e.induction_time;
				this.ruleForm.staff_telephone = e.staff_telephone;
				this.ruleForm.project_name = e.project_name;
				this.ruleForm.modular_name = e.modular_name;
				this.ruleForm.company_name = e.company_name;
				this.ruleForm.post_name = e.post_name;
				this.ruleForm.formal_salary = e.formal_salary;
				this.ruleForm.id = e.id;
				this.trash();
			},
			//添加
			AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			Update() {
				this.centerDialogVisible = false;
				axios({
						url: this.$globals.http + '/staff/updateStaff',
						method: 'post',
						data: {
							id: this.ruleForm.id,
							formal_date: this.ruleForm.formal_date,
							formal_salary: this.ruleForm.formal_salary,
							examineDetailsList: this.ruleForm.examineDetailsList,
							is_formal: '1',
						},
					})
					.then((response) => {
						var code = response.data.code;
						var data = response.data.data;
						if (code === '200') {
							this.$message.success(data);
							this.trash();
							this.Find();
							this.dialogAuditorVisible = false;
						} else {
							this.$message.warning('请求失败！请稍后重试');
						}
					})
					.catch((error) => {
						console.log(error);
						this.$message.error('服务器未响应！请稍后重试');
					});
			},
			//清除数据
			trash() {
				this.ruleForm.company_id = '';
				this.ruleForm.modular_id = '';
				this.ruleForm.city_name = '';
				this.ruleForm.project_id = '';
				this.ruleForm.post_id = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.start_date = '';
				this.ruleForm.end_date = '';
				this.ruleForm.staff_age = '';
				this.ruleForm.induction_salary = '';
				this.ruleForm.induction_time = '';
				this.ruleForm.staff_telephone = '';
				this.ruleForm.city_id = '';
				this.ruleForm.is_rehire = '';
				this.ruleForm.formal_date = '';
				this.ruleForm.is_formal = '';
				this.ruleForm.staff_card = '';
				this.ruleForm.project_name = '';
				this.ruleForm.modular_name = '';
				this.ruleForm.company_name = '';
				this.ruleForm.post_name = '';
				this.ruleForm.formal_salary = '';
				this.ruleForm.examineDetailsList = [];
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			// this.Find();
			this.organizeFind();
			// 岗位
			var gwList = await this.$globals.AxiosPost('post/selectFind', {});
			this.gwList = gwList.data;
		},
	};
</script>

<style scoped>
	.el-aside {
		height: 700px;
		background-color: #fbfbfb;
	}

	.s {
		width: 260px;
		display: block;
		margin: 20px auto;
	}

	.bor {
		font-size: 20px;
	}

	.add {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #fff;
		background-color: #00724e;
	}

	.add2 {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #00724e;
		background-color: #fff;
		border: 1px solid #00724e;
	}

	.el-table {
		width: 850px;
		margin-top: 40px;
	}

	.el-pagination {
		width: 500px;
		text-align: center;
		margin-top: 30px;
	}

	.prev {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 390px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.ne {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 460px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.c {
		position: absolute;
		top: 1px;
		left: 560px;
	}

	.small {
		width: 50px;
		height: 20px;
	}

	.btn {
		width: 60px;
		height: 30px;
		position: absolute;
		background-color: #00724e;
		top: 5px;
		left: 680px;
		color: #fff;
		border-radius: 5px;
	}

	.input {
		width: 200px;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.rz {
		margin-top: 20px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 150px;
	}

	.el-dropdown /deep/ .el-button-group .el-button {
		width: 90px;
	}

	.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
		background-color: #00724e;
	}

	.el-table /deep/ thead {
		color: #000;
		font-weight: 700;
		background-color: #f0f0f0;
	}

	.bm {
		position: relative;
		height: 100px;
	}

	.el-button {
		background-color: #00724e;
		color: #fff;
		width: 100px;
	}

	.Time {
		margin-left: 80px;
	}

	.time {
		margin-bottom: 20px;
	}

	.money {
		margin-bottom: 50px;
	}

	.el-button--qian {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// Ygzz.vue?4f227eed